import React, { useContext, useMemo, useCallback } from 'react';
import { Icon, useNavigationValuesWithRef } from '@synergy-marine-group/synergy-ui';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from './providers/AuthProvider';

export let user = null; // eslint-disable-line
export const NavigationContext = React.createContext();
export default function NavigationProvider({ children }) {
  const [accessibleRoles, setAccessibleRoles] = React.useState([]);

  const { getUser } = useContext(AuthContext);

  const [navigationMenu, setNavigationMenu] = React.useState([]);
  const location = useLocation();

  const processNavigationMenu = useCallback(
    (sourceMenu, clientRoles) => {
      return sourceMenu?.filter((navigationMenuItem) => {
          let isFound = false;

          if (!navigationMenuItem?.accessibleRoles
          ) {
            return true;
          }
          clientRoles?.forEach((clientRole) => {
            if (!isFound) {
              navigationMenuItem?.accessibleRoles?.forEach((ar) => {
                if (clientRole?.toLowerCase()?.split(/[ -]+/)?.join('_') === ar?.toLowerCase()?.split(/[ -]+/)?.join('_')) {
                  isFound = true;
                }
              });
            }
          });
          return isFound;
        })
        ?.map((element) => {
          return {
            title: element?.title,
            url: element?.url,
            type: process.env.DOMAIN_APP === element?.domainApp ? 'local' : 'external',
            external: element?.domainApp,
            openinnewwindow: true,
            icon: <Icon variant="filled" size="large" opacity={100} colour="white" type={element?.iconClass} />,

            alt: element?.title,
            iconName:
              process.env.DOMAIN_APP === element?.domainApp && element?.url === '/' && location?.pathname === '/' ? 'dashboard' : undefined
          };
        });
    },
    [location?.pathname]
  );

  const [isNavigationLoaded, setIsNavigationLoaded] = React.useState(false);

  React.useEffect(() => {
    if (accessibleRoles.length === 0) {
      getUser().then((value) => {
        user = value.profile;

        const userRole = Array.isArray(value.profile.role)
          ? value.profile.role : [value.profile.role];

        if (accessibleRoles !== userRole) {
          setAccessibleRoles(userRole);

          let navigationMenuItem = [];
          setTimeout(async () => {
            try {
              const headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
                axios.get(`${process.env.REACT_APP_MASTERLCP_ENDPOINT}/NavigationMenus`, { headers }).then((resp) => {
                  navigationMenuItem = resp?.data;
                  const newMenu = processNavigationMenu(navigationMenuItem, userRole);
                  setIsNavigationLoaded(true);
                  const userProfile = JSON.parse(
                    localStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`)
                  ).profile;
                  const hasVendorRole = userProfile?.user_type?.toLowerCase() === 'external vendor';
                  if (hasVendorRole) {
                    setNavigationMenu([]);
                  } else {
                    setNavigationMenu(newMenu);
                  }
                });
            } catch (e) {
              //
            }
          }, 0);
        } else {
          setAccessibleRoles([null]);
          setNavigationMenu([]);
        }
      });
    }
  }, [isNavigationLoaded]);

  const userdata = useMemo(() => {
    let userProfile;

    try {
      userProfile = JSON.parse(
        localStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`)
      ).profile;
    } catch {
      console.log('Unable to obtain authentication information');
    }
    return {
      firstName: userProfile?.first_name || '',
      lastName: userProfile?.last_name || ''
    };
  }, []);

  const [navRef,
    navRefCb,
    { marginLeftForMain },
    { isPinned, setIsPinned }] = useNavigationValuesWithRef();

  const onClickPin = () => {
    window.localStorage.setItem('isPinned', 'true');
    setIsPinned(true);
  };
  const onClickUnpin = () => {
    window.localStorage.setItem('isPinned', 'false');
    setIsPinned(false);
  };

  const navMenuItems = [
    ...navigationMenu,
    {
      icon: <span className="material-icons filled text-4xl">help</span>,
      url: process.env.REACT_APP_HELP_LINK,
      title: 'Help',
      openinnewwindow: true,
      external: true
    }
  ];

  return (
    <NavigationContext.Provider
      value={{
        menuitems: navMenuItems,
        isNavigationLoaded,
        showNavigation: true,
        userdata,
        bottommenu: [
          {
            title: 'Settings',
            url: `${process.env.REACT_APP_SALES_SERVICE_URL}settings?url_ref=kaas`,
            openinnewwindow: true,
            external: true
          },
          {
            title: 'My Profile',
            url: process.env.REACT_APP_MY_PROFILE,
            openinnewwindow: true,
            external: true
          },
          {
            title: 'Change Password',
            url: process.env.REACT_APP_CHANGE_PASSWORD_URL,
            openinnewwindow: true,
            external: true
          }
        ],
        marginLeftForMain,
        onClickPin,
        onClickUnpin,
        navRef,
        navRefCb,
        isPinned
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
}
